var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lv-flex-box",class:{ 'no-wrap': _vm.noWrap, 'gap-8': _vm.gap8, 'gap-4': _vm.gap4 },style:({
    'flex-direction': _vm.flexDirection,
    'justify-content': _vm.justifyContent,
    'align-items': _vm.alignItems,
    width: _vm.width,
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }